﻿<script lang="ts" context="module">
	function buildFormData(formData, data, parentKey?) {
		if (
			data &&
			typeof data === "object" &&
			!(data instanceof Date) &&
			!(data instanceof File)
		) {
			Object.keys(data).forEach((key) => {
				buildFormData(
					formData,
					data[key],
					parentKey ? `${parentKey}[${key}]` : key
				);
			});
		} else {
			const value =
				data === null
					? ""
					: data instanceof Date
					? data.toJSON()
					: data;
			formData.append(parentKey, value);
		}
	}

	function jsonToFormData(data) {
		const formData = new FormData();
		buildFormData(formData, data);
		return formData;
	}

	export function callApi(url, params) {
		return window
			.fetch(url, {
				credentials: "same-origin",
				method: "POST",
				body: jsonToFormData(params),
			})
			.then((r) => {
				return r.json();
			})
			.then((x) => {
				if (x.status === "Ok")
					return x.result;

				return Promise.reject();
			});
	}
</script>
